/**
 * Default artwork for event cards when `background_image_url` is not set.
 * Display-only — the API may still store undefined until the user saves a URL.
 */
export const DEFAULT_EVENT_BACKGROUND_IMAGE_URL =
  "https://static.vecteezy.com/system/resources/previews/022/609/799/original/fun-educational-images-with-educational-materials-funny-kid-flying-on-colorful-pencil-cartoon-vector.jpg";

/**
 * @param {unknown} url - Stored `background_image_url` from the API
 * @returns {string} URL to use for hero banner / card background
 */
export function resolveEventBackgroundImageUrl(url) {
  const t = url != null && typeof url === "string" ? url.trim() : "";
  return t || DEFAULT_EVENT_BACKGROUND_IMAGE_URL;
}
